<foo-control-label [templateOptions]="templateOptions" [control]="control"></foo-control-label>
<ng-container *ngIf="(templateOptions?.showNoSelectionOption || templateOptions.disableOption || templateOptions.hideOption) && !templateOptions.dataSource">
  <ng-select appNgSelectCustom
             class="form-control"
             [multiple]="templateOptions?.multiple"
             [selectReadonly]="templateOptions?.readonly"
             (change)="templateOptions?.onChange && templateOptions?.onChange($event)"
             [placeholder]='placeholder | translate'
             [hideSelected]="true"
             [clearable]="templateOptions?.clearable"
             [searchable]="templateOptions?.searchable"
             [formControl]="control">
    <ng-container *ngIf="templateOptions?.showNoSelectionOption">
      <ng-option [value]="null">{{ noSelectionOptionText | translate }}</ng-option>
    </ng-container>
    <ng-container *ngFor="let item of templateOptions?.items; let index = index;">
      <ng-option
        *ngIf="templateOptions.hideOption ? templateOptions.hideOption(item[keyProp]) : true"
        [disabled]="templateOptions.disableOption ? templateOptions.disableOption(item[keyProp]) : false"
        [value]="item[keyProp]">
        <ng-container
          *ngTemplateOutlet="getTemplate(optionTemplate); context: { item: item, index: index ,configs:configs}">
        </ng-container>
      </ng-option>
    </ng-container>
  </ng-select>
</ng-container>

<ng-container *ngIf="!templateOptions?.showNoSelectionOption && !templateOptions.disableOption && !templateOptions.hideOption &&  !templateOptions.dataSource">
  <ng-select appNgSelectCustom
             class="form-control"
             [selectReadonly]="templateOptions?.readonly"
             [items]="templateOptions?.items"
             [bindLabel]="titleProp"
             [bindValue]="keyProp"
             (change)="templateOptions?.onChange && templateOptions?.onChange($event)"
             [formControl]="control"
             [placeholder]="placeholder | translate"
             [hideSelected]="true"
             [clearable]="templateOptions?.clearable"
             [searchable]="templateOptions?.searchable"
  >
    <ng-template ng-label-tmp let-item="item" *ngIf="!templateOptions?.multiple">
      <ng-container
        *ngTemplateOutlet="getTemplate(labelTemplate); context: { item: item,configs:configs}">
      </ng-container>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index">
      <ng-container
        *ngTemplateOutlet="getTemplate(optionTemplate); context: { item: item, index: index ,configs:configs}">
      </ng-container>
    </ng-template>
  </ng-select>
</ng-container>

<ng-container *ngIf="templateOptions.dataSource">
  <foo-searchable-select
    [dataSource]="templateOptions.dataSource"
    [formControl]="control"
    [multiple]="templateOptions.multiple"
    [titleProp]="templateOptions.titleProp"
    [keyProp]="templateOptions.keyProp"
    [placeholder]="templateOptions.placeholder"
    [labelTemplate]="templateOptions.labelTemplate"
    [optionTemplate]="templateOptions.optionTemplate"
    [clearable]="templateOptions?.clearable"
    [searchable]="templateOptions?.searchable"
  >

  </foo-searchable-select>
</ng-container>



<foo-control-errors *ngIf="!templateOptions?.readonly && !templateOptions?.hideErrors"  [control]="control" [errorMessages]="errors"></foo-control-errors>

<ng-template [frameworkTemplate]="'selectDefault'" let-item="item">
  {{item[titleProp]| translate}}
</ng-template>
<ng-template [frameworkTemplate]="'keyValue'" let-configs="configs" let-item="item">
  <div class="d-flex flex-column">
    <ng-container *ngFor="let configList of configs;">
      <div class="d-flex align-items-baseline gap-1 lh-1">
        <ng-container *ngFor="let config of configList; let last = last">
          <span *ngIf="config?.key" [ngClass]="config?.keyClassName" class="text-break" [innerHTML]="config.key | translate | trustedHtml"></span>
          <span *ngIf="config?.value || config?.formatter" [ngClass]="config?.valueClassName" class="text-break" 
                [innerHTML]="(config?.formatter ? config.formatter(item) : (item | stringobject: config?.value)) | trustedHtml">
          </span>
          <span *ngIf="!last && config?.delimiter" [innerHTML]="config?.delimiter | trustedHtml"> </span>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>